<template>
  <div>
    <header-images-preview 
      :data_header="data_header" 
      :is_avaible_to_editing="is_avaible_to_editing"
      @edit_proposal="$emit('edit_proposal', $event)"
    />

    <title-and-description-preview
      :data_header="data_header"
      :is_avaible_to_editing="is_avaible_to_editing"
      :is_free_proposal="is_free_proposal"
      @edit_proposal="$emit('edit_proposal', $event)"
      class="mt-1"
    />
  </div>  
</template>

<script>
import HeaderImagesPreview from '@/views/components/proposals/components/HeaderImagesPreview.vue';
import TitleAndDescriptionPreview from '@/views/components/proposals/components/TitleAndDescriptionPreview.vue';
import { redirectLastRoute } from '@/libs/utils/others'
import { getAssetUrl, isUrl, verifyAsset } from '@/libs/utils/urls';
import { isVideo } from '@/libs/utils/formats';

export default {
  name: 'headerPreviewSteps',
  components: {
    HeaderImagesPreview,
    TitleAndDescriptionPreview,
  },
  data() {
    return {
      verifyAsset,
      isUrl,
      getAssetUrl,
      isVideo,
      redirectLastRoute,
      isChatRoute: false,
    }
  },
  props: {
    data_header: {
      type: Object,
      default: () => {
        return {}
      }
    },
    is_free_proposal: {
      type: Boolean,
      default: true
    },
  },
  
  created() {
    if (this.$route.matched.some(route => route.path === '/proposal/chat/:chat_uuid?')) {
      this.isChatRoute = true;
    }
  },
  computed: {
    is_avaible_to_editing() {
      return !this.$route.params.vanity_name;
    },
  },
  methods: {
    redirectionProposals(key_name, value) {
      this.$router.push({name: 'creadores', query: {[key_name]: value}});
      this.$root.$emit('update_proposals');
    },
    getTranslateType(text) {
      return this.$t(`creator.type_of_work`).find((type) => type.value === text).text;
    },
    getTranslateContent(text) {
      return this.$t(`creator.focus_in_${this.data_header.work_type}`).find((type) => type.value === text).text;
    }
  }
}
</script>
<style>
strong {
  font-family: 'avenir-bold' !important;
}
</style>
<style scoped lang="scss">

.text-work-type {
  color: #3483fa;
  margin-right: 5px;
  margin-left: 5px;
} 
.text-work-type:hover {
  color: #2968c8;
  cursor: pointer;
} 

.background-button-edit {
  background-color: transparent;
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  border-radius: 0.55em;
}
.animation-opacity-words {
  opacity: 0;
}
.categories-subcategories:hover .background-button-edit {
  background-color: #3b8da888;
  transition: all 500ms;
  cursor: pointer;
  backdrop-filter: blur(10px);
}
.categories-subcategories:hover .animation-opacity-words {
  opacity: 1;
  transition: all 500ms;
}
.categories-subcategories:not(:hover) .animation-opacity-words,
.categories-subcategories:not(:hover) .background-button-edit {
  transition: all 500ms;
}
.categories-subcategories {
  padding: 1em 0 0 0;
}
.bubble-edit {
  text-align: left;
  /* position: relative; */
  /* height: auto; */
  /* width: 100%; */
  padding: 1em;
  color: #3b8DA8;
  background: #E6f2f6;
  border-radius: 1em;
  cursor: pointer;
  position: sticky  ;
  position: -webkit-sticky;
  top: 12em;
}
.bubble-edit:hover {
  transition: all 300ms;
  background: #3b8da82f;
}
.bubble-edit:before {
  border: 10px solid #E6f2f6;
  content: '';
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-right-color: transparent;
  position: absolute;
  transform: rotate(90deg);
  left: -20px;
}
.bubble-edit:hover:before {
  border: 10px solid #3b8da82f;
  content: '';
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-right-color: transparent;
  position: absolute;
  transform: rotate(90deg);
  left: -20px;
  transition: all 300ms;
}
.light-secondary-v2 {
  background-color: #e8e8e8;
  color: #718096;
  font-weight: 400;
}
</style>
